import Axios from "axios";
import { Observable } from "rxjs";
import { from } from "rxjs";
import { map } from "rxjs/operators";

import { PACE_API } from "../shared/url.consts";
import { GetContinueTokenResponse } from "./get-application.response";

export function getContinueToken(
  token: string
): Observable<{ continueToken: string }> {
  return from(
    Axios.get<GetContinueTokenResponse>(
      `${PACE_API}/api/brokers/application/logintoken?token=${token}`
    )
  ).pipe(
    map((res) => ({
      continueToken: res.data.ContinueToken,
    }))
  );
}
